import React from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Explicit from '@mui/icons-material/Explicit';
import OfferPartnerEligibilityForm from './OfferPartnerEligibilityForm';
import { updateOfferPartnerEligibility, loadPartnerEligibility } from '../actionCreators';
import { getEligibilitiesIsLoaded, getOfferPartnerEligibilities } from '../selectors';
import { CollapseCard } from '@totalsoft/rocket-ui';

class OfferPartnerEligibilityContainer extends React.PureComponent {
  state = {
    expanded: false,
    eligibility: this.props.partnerEligibility,
    isValid: true,
    isDirty: false
  };

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.partnerEligibility && prevProps.partnerEligibility !== this.props.partnerEligibility) {
      this.loadData();
      this.setState({
        eligibility: this.props.partnerEligibility
      });
    }
  }

  loadData = async () => {
    if (this.props.partnerId)
      await this.props.actions.loadPartnerEligibility(this.props.documentId, this.props.siteId, this.props.partnerId);
  };

  handleChange = (value, eligibilityId) => {
    const options = this.state.eligibility;

    const index = options.findIndex(x => x.eligibilityId === eligibilityId);
    if (index === -1) {
      return;
    }

    const newOptions = Object.assign([...options], { [index]: { ...options[index], selectedValue: value } });
    const isDataValid = newOptions.reduce((acc, cv) => acc && !!cv.selectedValue, true);

    this.setState({
      eligibility: newOptions,
      isDirty: true,
      ...(isDataValid && { isValid: isDataValid })
    });
  };

  onSave = async () => {
    const isDataValid = this.state.eligibility.reduce((acc, cv) => acc && !!cv.selectedValue, true);

    this.setState({
      isValid: isDataValid
    });

    if (!isDataValid) return;

    let data = {
      documentId: this.props.documentId,
      siteId: this.props.siteId,
      partnerId: this.props.partnerId,
      eligibility: this.state.eligibility.map(a => {
        return {
          eligibilityId: a.eligibilityId,
          selectedValue: a.selectedValue,
          name: a.name
        };
      })
    };

    await this.props.actions.updateOfferPartnerEligibility(data);
    this.setState({
      expanded: false,
      isDirty: false
    });
  };

  onCardToggle = (_, expanded) => {
    this.setState({ expanded: !expanded });
    if (!expanded) this.loadData();
  };

  render() {
    const { t } = this.props;
    const { expanded, eligibility, isValid, isDirty } = this.state;

    return (
      eligibility?.length > 0 && (
        <CollapseCard
          id={'offerPartnerEligibilityCard'}
          icon={Explicit}
          title={t('OfferEdit.Client.Eligibility.Title')}
          expanded={expanded}
          onToggle={this.onCardToggle}
          toggleOnHeaderClick
        >
          <OfferPartnerEligibilityForm
            data={eligibility}
            isValid={isValid}
            isDirty={isDirty}
            onChange={this.handleChange}
            onSave={this.onSave}
          />
        </CollapseCard>
      )
    );
  }
}

OfferPartnerEligibilityContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  partnerEligibility: PropTypes.array.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  partnerId: PropTypes.number.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    partnerEligibility: getOfferPartnerEligibilities(state, ownProps.partnerId),
    isLoaded: getEligibilitiesIsLoaded(state, ownProps.partnerId)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ updateOfferPartnerEligibility, loadPartnerEligibility }, dispatch),
    dispatch
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(OfferPartnerEligibilityContainer);
